import styles from "./quote-block.module.less";
import { getImageLoading } from "../../../helpers";
import type { TImage, TIndexableBlock } from "../../../types";
import { m as motion } from "motion/react";
import Heading from "../../elements/heading/heading";

import { TAnimationConditions, useAnimateFadeIn } from "../../../animation/animation";

export type TQuote = {
  quote: string;
  name: string;
  workTitle: string;
  image: TImage;
};

export type TQuoteBlockProps = {
  quotes: Array<TQuote>;
} & TIndexableBlock;

const Quote = ({ quote, name, workTitle, image, blockIndex }: TQuote & { blockIndex?: number }) => {
  const conditions: TAnimationConditions = { blockIndex: blockIndex };
  const fadeInAnimation = useAnimateFadeIn({ whileInView: true, easing: "easeInOut" }, conditions);

  return (
    <div className={styles.quoteWrapper}>
      <motion.div {...fadeInAnimation} className={styles.textWrapper}>
        {quote && (
          <Heading
            index={blockIndex}
            semanticType={"h3"}
            visualType={"h4"}
            className={[styles.quote, "heading-max-width"].join(" ")}
          >
            {`"${quote}"`}
          </Heading>
        )}
        {(name || workTitle) && (
          <div className={styles.nameAndTitle}>
            {(name || workTitle) && (
              <p className={[styles.workTitle, "eyebrow"].join(" ")}>{[name, workTitle].join(", ")}</p>
            )}
          </div>
        )}
      </motion.div>
      <motion.div {...fadeInAnimation} className={styles.backgroundMediaWrapper}>
        <div className={styles.imageWrapper}>
          <img className={styles.image} src={image.url} alt={image.alt} loading={getImageLoading(blockIndex)} />
        </div>
      </motion.div>
    </div>
  );
};

export const QuoteBlock = ({ quotes = [], index }: TQuoteBlockProps) => {
  return (
    <section className={styles.wrapper}>
      <div className={[styles.contentWrapper, "max-width centered padded-sides"].join(" ")}>
        <ul className={styles.blockList}>
          {quotes.map((quote) => {
            return (
              <li key={quote.quote}>
                <Quote blockIndex={index} {...quote} />
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default QuoteBlock;
